<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_search') ||
                  '工厂订单编号/客户订单号/产品名称/员工工号姓名 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot :form="form" />
            <!-- <b-button
              v-if="allow('A')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditPage', { pageType: 'add' })"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button> -->
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" label-width="100px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="'状态'">
              <el-checkbox-group v-model="form.listStatus">
                <el-checkbox label="N">{{ '草稿' }}</el-checkbox>
                <el-checkbox label="S">{{ '已提报' }}</el-checkbox>
                <el-checkbox label="U">{{ '已审核' }} </el-checkbox>
                <el-checkbox label="D">{{ '已删除' }} </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="'客户订单编号'">
              <el-input
                v-model="form.custOrderNo"
                :maxlength="500"
                clearable
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'产品名称'">
              <el-input
                v-model="form.goodsName"
                :maxlength="500"
                clearable
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'工厂订单编号'">
              <el-input
                v-model="form.factoryOrderNo"
                :maxlength="500"
                clearable
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'员工姓名'">
              <el-input
                v-model="form.userName"
                clearable
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'子件编码'">
              <el-input
                v-model="form.ncNo"
                clearable
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'成品编码'">
              <el-input
                v-model="form.masterNcNo"
                clearable
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'产品分类'" prop="categoryCode">
              <category-cascader
                :detailCategoryCode.sync="form.categoryCode"
                :masterCategoryCode.sync="form.masterCategoryCode"
                :categoryFullName.sync="form.categoryFullName"
                :params="{ parentCode: 'ABSHome', isEcom: 'N' }"
                clearable
              ></category-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'客户'">
              <dict-select
                clearable
                v-model="form.custCodeList"
                filterable
                multiple
                url="/master/common/dict/customerSelect"
                style="width:100%"
                :placeholder="''"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="'创建人'">
              <dict-select
                v-model="form.createByList"
                url="/master/common/dict/baseUserSelect"
                filterable
                clearable
                :placeholder="''"
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="'创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'修改人'">
              <dict-select
                v-model="form.modifyByList"
                url="/master/common/dict/baseUserSelect"
                filterable
                clearable
                :placeholder="''"
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="'修改时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeStart"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeEnd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="'报工日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.workLogTimeStart"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.workLogTimeEnd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_pdProcessDictStep') || '报工工序'"
              prop="pdProcessDictStep"
            >
              <dict-select-page
                v-model="form.pdProcessDictStep"
                url="/master/common/dict/biz"
                :body="{ dictType: 'pdProcessDictStep' }"
                :placeholder="''"
                size="mini"
                style="width: 100%"
                filterable
                clearable
                :selectedLabel.sync="form.processName"
                @change="
                  () => {
                    form.pdTechDictCodeList = [];
                  }
                "
              ></dict-select-page>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_techName') || '工艺名称'"
              prop="pdTechDictCodeList"
            >
              <dict-select-page
                v-model="form.pdTechDictCodeList"
                url="/factory/pd/tech/dictionary/listByChoose"
                :body="{
                  pdProcessDictStep: form.pdProcessDictStep,
                  listPdTechDictStatus: ['Y'],
                }"
                :placeholder="''"
                :options="{ label: 'techName', value: 'pdTechDictCode' }"
                size="mini"
                style="width: 100%"
                filterable
                remote-filter
                search-key="techName"
                clearable
                multiple
              ></dict-select-page>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'

// 初始表单
const initForm = () => ({
  keyword: '',
  listStatus: ['N', 'S', 'U'],
  workLogTimeStart: dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
  workLogTimeEnd: dayjs().format('YYYY-MM-DD'),
})
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm() },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')

      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm() }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
